const baseRoutes = [
	{ name: 'app.start', path: '/', redirect: { name: 'Dashboard' }, meta: { layout: 'auth' } },
	{
		name: 'app.home',
		meta: { requiresAuth: true },
		redirect: { name: 'Dashboard' },
		component: () => import('#modules/home/HomeModule.vue'),
		children: [
			{
				name: 'Dashboard',
				path: '/',
				component: () => import('#modules/home/pages/DashboardPage.vue'),
			},
		],
	},
	{
		name: '403',
		path: '/403',
		meta: { requiresAuth: true },
		component: () => import('#modules/base/pages/NotAuthorized.vue'),
	},
	{
		name: '404',
		path: '/404',
		meta: { requiresAuth: true },
		component: () => import('#modules/base/pages/NotFound.vue'),
	},
	{
		name: 'test',
		path: '/test',
		meta: { layout: 'none' },
		component: () => import('#src/components/Debug/TestPage.vue'),
		children: [
			{
				name: 'test.colors',
				path: 'colors',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/ColorSheet.vue'),
			},
			{
				name: 'test.dates',
				path: 'dates',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/DateSheet.vue'),
			},
			{
				name: 'test.errors',
				path: 'errors',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/ErrorSheet.vue'),
			},
			{
				name: 'test.form',
				path: 'form',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/FormSheet.vue'),
			},
			{
				name: 'test.formfields',
				path: 'formfields',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/FormFieldsSheet.vue'),
			},
			{
				name: 'test.buttons',
				path: 'buttons',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/ButtonSheet.vue'),
			},
			{
				name: 'test.typography',
				path: 'typography',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/TypographySheet.vue'),
			},
			{
				name: 'test.tooltips',
				path: 'tooltips',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/TooltipSheet.vue'),
			},
			{
				name: 'test.editor',
				path: 'editor',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/EditorSheet.vue'),
			},
			{
				name: 'test.canvas',
				path: 'canvas',
				meta: { layout: 'none' },
				component: () => import('#src/components/Debug/CanvasSheet.vue'),
			},
		],
	},
]

export default baseRoutes
